import React, { useEffect, useState } from "react";
import classes from "./NDAContentModeration.module.css";
import SideBarSkeleton from "@/components/Core/SideBarSkeleton";
import { Button } from "@/components/Core/Button";
import Box from "@/components/Box";
import HTMLReactParser from "html-react-parser";
import QuillInput from "@/components/QuillInput";
import { FaEdit } from "react-icons/fa";
import { Get, Patch } from "@/axios/AxiosFunctions";
import { BaseURL } from "@/config/apiUrl";
import Skeleton from "@/components/Skeleton";
import { useSelector } from "react-redux";
import { apiHeader, RenderToast } from "@/helper/HelperFunction";
import { useNavigate } from "react-router-dom";
import { MdClose } from "react-icons/md";
const loadingState = {
  POSTING: "posting",
  FETCHING: "fetching",
};
function NDAContentModeration() {
  const { access_token } = useSelector((state) => state.authReducer);
  const [formData, setFormData] = useState("");
  const [isEditable, setIsEditable] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const getNDAContent = async () => {
    setLoading(loadingState.FETCHING);
    const url = BaseURL("app-config/find/nda");
    const response = await Get(url, access_token);
    if (response !== undefined) {
      setFormData(response?.data?.nda);
    }
    setLoading(false);
  };
  useEffect(() => {
    getNDAContent();
  }, []);
  const handleSaveNDAContent = async () => {
    setLoading(loadingState.POSTING);
    const url = BaseURL("app-config/update/nda");
    const response = await Patch(
      url,
      {
        nda: formData,
      },
      apiHeader(access_token)
    );
    if (response !== undefined) {
      RenderToast({
        type: "success",
        message: "NDA Content Updated Successfully",
      });
    }
    setLoading(false);
  };
  return (
    <SideBarSkeleton>
      <div className={classes.container}>
        <div className={classes.header}>
          <p className={classes.pageHeading}>NDA Content Moderation</p>
          <Button
            label={isEditable ? "Back to View" : "Edit"}
            leftIcon={isEditable ? <MdClose /> : <FaEdit />}
            customStyle={{ width: "fit-content", height: "45px" }}
            onClick={() => {
              setIsEditable(!isEditable);
            }}
          />
        </div>
        {loading ? (
          <Skeleton height={400} width="100%" />
        ) : (
          <Box>
            {isEditable ? (
              <QuillInput value={formData} setter={setFormData} />
            ) : (
              <div className={classes.content}>{HTMLReactParser(formData)}</div>
            )}
          </Box>
        )}
        {isEditable && (
          <div className={classes.btnContainer}>
            <Button
              label={loading == loadingState.POSTING ? "Saving..." : "Save"}
              onClick={handleSaveNDAContent}
              customStyle={{ width: "fit-content" }}
            />
            <Button
              label="Cancel"
              variant="danger"
              onClick={() => {
                setIsEditable(false);
              }}
              customStyle={{ width: "fit-content" }}
            />
          </div>
        )}
      </div>
    </SideBarSkeleton>
  );
}

export default NDAContentModeration;

const NDAFormData = `
  <strong>Non-Disclosure Agreement (NDA)</strong>
  <hr />
  <strong>Flex Drive LTD</strong>
  <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
  <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>
  <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
  <strong>Booking</strong>
  <ol>
      <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</li>
      <br />
      <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</li>
      <br />
      <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."</li>
      <br />
      <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</li>
      <br />
      <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</li>
      <br />
      <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</li>
      <br />
      <li>
      Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur.</li>
      <br />
      <li>On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire, that they cannot foresee the pain and trouble that are bound to ensue; and equal blame belongs to those who fail in their duty through weakness of will, which is the same as saying through shrinking from toil and pain. These cases are perfectly simple and easy to distinguish.</li>
      <br />
      <li>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy.</li>
  </ol>
  <hr />
  `;
